<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 aarni-font">{{ pageTitle }}</h1>
    </div>
</div>

<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 h-fit overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Downloads</h2>
                    <div class="">
                        <a [href]="'/downloads/brochure'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Brochure', 'text-blue-600 bg-white' : pageTitle !== 'Brochure'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Brochure</span>
                        </a>
                        <a [href]="'/downloads/registration-form'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Registration Form', 'text-blue-600 bg-white' : pageTitle !== 'Registration Form'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Registration Form</span>
                        </a>
                        <a [href]="'/downloads/guidelines'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Guidelines', 'text-blue-600 bg-white' : pageTitle !== 'Guidelines'}"
                           class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Guidelines</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        <span class="text-gray-700 font-medium text-xl pl-4">Testimonials</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/whats-happening/event-calendar" class="flex items-center space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">
                          <i class="fa fa-calendar text-2xl"></i>
                        </span>
                        <span class="text-gray-700 font-medium text-xl pl-4">What's Happening</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span>
                        <span class="text-gray-700 font-medium text-xl pl-4">Contact Us</span>
                    </a>
                </div>
            </div>
            <!--       <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                       <div class="space-y-2">
                           <a href="/quick-links/image-gallery" class="flex items-center space-x-3 p-2 rounded-lg ">
                   <span class="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full">
                       <i class="fa fa-camera text-2xl"></i>
                   </span>
                               <span class="text-gray-700 font-medium text-xl pl-4">Image Gallery</span>
                           </a>
                       </div>
                   </div>-->
        </aside>
        <div class="flex-1">
            <div class="p-12 shadow-lg border-gray-200 bg-white h-fit border">
                <h3 class="font-semibold text-[22px] my-2">
                    {{ pageTitle }}
                </h3>
                <div *ngIf="pageTitle === 'Brochure'">
                    <div *ngFor="let item of accordionItems; let i = index"
                         class="border border-gray-300 rounded-md mb-2 overflow-hidden">
                        <div (click)="toggleAccordion(i)"
                             class="flex items-center cursor-pointer px-4 py-3 transition-colors duration-200 text-lg"
                             [ngClass]="{'text-blue-400': activeIndex === i, 'text-black': activeIndex !== i}">
      <span class="text-xl mr-3">
        {{ activeIndex === i ? '−' : '+' }}
      </span>
                            <h2 class="text-lg font-medium">
                                {{ item.title }}
                            </h2>
                        </div>

                        <div *ngIf="activeIndex === i" class="px-4 py-2 text-gray-700 border-t border-gray-200">
                            <a
                                [href]="'assets/pdf/brochures-as-per-schools/' + item.pdfFileName"
                                target="_blank"
                                rel="noopener"
                                class="text-blue-600 underline cursor-pointer">
                                {{ item.description }}
                            </a>
                        </div>


                        <!-- <div *ngIf="activeIndex === i" class="px-4 py-2 text-gray-700 border-t border-gray-200">
                             {{ item.description }}
                         </div>-->
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Registration Form'">
                    <div *ngFor="let item of accordionItems; let i = index"
                         class="border border-gray-300 rounded-md mb-2 overflow-hidden">
                        <div (click)="toggleAccordion(i)"
                             class="flex items-center cursor-pointer px-4 py-3 transition-colors duration-200 text-lg"
                             [ngClass]="{'text-blue-400': activeIndex === i, 'text-black': activeIndex !== i}">
      <span class="text-xl mr-3">
        {{ activeIndex === i ? '−' : '+' }}
      </span>
                            <h2 class="text-lg font-medium">
                                {{ item.title }}
                            </h2>
                        </div>

                        <div *ngIf="activeIndex === i" class="p-4 border-t border-gray-200">
                            <a [href]="'assets/pdf/forms/' + item.pdfFileName" target="_blank" rel="noopener"
                               class="text-blue-600 cursor-pointer underline">
                                {{ item.description }}
                            </a>
                        </div>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Guidelines'">
                    <p class="text-gray-500 mb-2">At ARNI University, we are not just committed but devoted to maintaining the highest standards of
                        academic integrity, administrative excellence, and student welfare. We have developed our
                        guidelines to ensure a smooth, transparent, and structured environment for all the students,
                        parents, teachers, and stakeholders.
                    </p>
                    <div *ngFor="let item of accordionItems; let i = index"
                         class="border border-gray-300 rounded-md mb-2 overflow-hidden">
                        <div (click)="toggleAccordion(i)"
                             class="flex items-center cursor-pointer px-4 py-3 transition-colors duration-200 text-lg"
                             [ngClass]="{'text-blue-400': activeIndex === i, 'text-black': activeIndex !== i}">
      <span class="text-xl mr-3">
        {{ activeIndex === i ? '−' : '+' }}
      </span>
                            <h2 class="text-lg font-medium">
                                {{ item.title }}
                            </h2>
                        </div>

                        <div *ngIf="activeIndex === i" class="px-4 py-2 text-gray-700 border-t border-gray-200"
                             [innerHTML]="item.description">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
